import React from "react";
import CesiumViewer from "./satmon/CesiumViewer";

function App() {

    return (        
        <CesiumViewer/>
    );
}

export default App;
